function currentPathname() {
  return typeof window === "undefined" ? "/" : window.location.pathname;
}

export function getCompanySlugFromPath(pathname = currentPathname()) {
  const match = pathname.match(/^\/(?:c|preview)\/([^/]+)(?:\/|$)/);
  return match ? decodeURIComponent(match[1]) : null;
}

export function publicApiBase(pathname = currentPathname()) {
  const companySlug = getCompanySlugFromPath(pathname);
  const prefix = pathname.startsWith("/preview/") ? "preview" : "c";
  return companySlug
    ? `/${prefix}/${encodeURIComponent(companySlug)}/api`
    : "/api";
}
